export default __webpack_public_path__ + "static/media/onBWorkExperienceVerify.ab2991a8.svg";